__turbopack_context__.v({
  "catalog": "plaza-module__MBPxiq__catalog",
  "description": "plaza-module__MBPxiq__description",
  "embedded": "plaza-module__MBPxiq__embedded",
  "eyebrow": "plaza-module__MBPxiq__eyebrow",
  "filters": "plaza-module__MBPxiq__filters",
  "hero": "plaza-module__MBPxiq__hero",
  "heroContent": "plaza-module__MBPxiq__heroContent",
  "hot": "plaza-module__MBPxiq__hot",
  "page": "plaza-module__MBPxiq__page",
  "search": "plaza-module__MBPxiq__search",
  "title": "plaza-module__MBPxiq__title",
});
